<template>
  <v-container>
    <v-row>
      <v-col cols="7" align="right">
        <TextButton class="secondary card py-y mt-2 px-8" elevation="8" to="/profesionalizacion/registro_aula"
          >Nueva aula <v-icon small class="ml-2">mdi-plus</v-icon></TextButton
        >
      </v-col>
      <v-col cols="12" lg="4">
        <v-text-field
          v-model="buscaAula"
          color="secondary"
          background-color="primary"
          rounded
          filled
          placeholder="Buscar aula por nombre..."
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col lg="1">
        <v-btn-toggle v-model="ordenAlfabetico" class="card" rounded mandatory>
          <v-btn icon>
            <v-icon color="secondary darken-2">mdi-order-alphabetical-ascending</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon color="secondary darken-2">mdi-order-alphabetical-descending</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="buscaAula.length > 0">
        <div class="text-h6 font-weight-bold">
          {{ filteredAulas.length }} resultados encontrados con la búsqueda "{{ buscaAula }}"
        </div>
      </v-col>
      <v-expansion-panels flat class="card" focusable hover mandatory>
        <v-expansion-panel v-for="(grupoAulas, index) in groupedAulas" :key="index">
          <v-expansion-panel-header>
            <div>
              <div class="text-h6 secondary--text font-weight-bold d-inline">
                {{ grupoAulas.inicial }}
              </div>
              <div class="text-overline d-inline secondary--text">({{ grupoAulas.aulas.length }})</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container>
              <v-row>
                <v-col cols="12" lg="4" xl="3" v-for="aula in grupoAulas.aulas" :key="aula.id">
                  <v-card class="card" color="secondary" elevation="8">
                    <v-card-title>
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="center">
                            <v-avatar rounded color="primary" size="80">
                              <v-icon x-large color="secondary">mdi-cast-education</v-icon>
                            </v-avatar>
                          </v-col>
                          <v-col cols="12" align="center">
                            <div class="text-h6 primary--text font-weight-bold">{{ aula.aula }}</div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-title>
                    <v-card-text>
                      <v-container> </v-container>
                    </v-card-text>
                    <v-card-actions class="secondary darken-1">
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="center">
                            <v-tooltip bottom color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :to="{ name: 'updateClassroom', params: { id: aula.id } }"
                                  class="primary secondary--text mx-2"
                                  elevation="8"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-pencil</v-icon></v-btn
                                >
                              </template>
                              <span>Editar aula</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import TextButton from '@src/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },
  data() {
    return {
      buscaAula: '',
      ordenAlfabetico: 0,
    }
  },

  computed: {
    ...mapGetters('aula', {
      aulas: 'getAulas',
    }),

    filteredAulas: function () {
      return this.aulas.filter((aula) => {
        return aula.aula.toLowerCase().indexOf(this.buscaAula.toLowerCase()) >= 0
      })
    },

    groupedAulas: function () {
      var result = _(this.filteredAulas)
        .groupBy((aula) => aula.aula[0].toUpperCase())
        .map((aulas, inicial) => ({ inicial, aulas }))
        .value()

      if (this.ordenAlfabetico == 0) {
        result.sort(function (a, b) {
          if (a.inicial < b.inicial) {
            return -1
          }
          if (a.inicial > b.inicial) {
            return 1
          }
          return 0
        })
      } else {
        result.sort(function (a, b) {
          if (a.inicial > b.inicial) {
            return -1
          }
          if (a.inicial < b.inicial) {
            return 1
          }
          return 0
        })
      }
      return result
    },
  },
}
</script>
